import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Space } from 'antd';
import {
    FacebookOutlined,
    TwitterOutlined,
    InstagramOutlined,
    LinkedinOutlined,
    MailOutlined,
    PhoneOutlined,
    EnvironmentOutlined,
    AppleOutlined
} from '@ant-design/icons';
import { APP_NAME, COPYRIGHT_YEAR, GOOGLE_PLAY_URL, APP_STORE_URL, APP_STORE_AVAILABLE } from '../../common/constants';
import Logo from '../../assets/logo-tigoon.png';
import YangoLogo from '../../assets/logo-yango.png';
import WarenLogo from '../../assets/logo-waren.png';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <Row gutter={[48, 32]}>
                    {/* About Section */}
                    <Col xs={24} sm={24} md={8}>
                        <div className="footer-section">
                            <div className="footer-logo">
                                <img src={Logo} alt={APP_NAME} className="footer-logo-image" />
                            </div>
                            <p className="footer-description">
                                Tous vos services en une seule application : courses, livraisons,
                                boutique et assistance. Pour les chauffeurs, les livreurs et les commerçants.
                            </p>
                            <Space size={16} className="social-links">
                                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                                    <FacebookOutlined />
                                </a>
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                                    <TwitterOutlined />
                                </a>
                                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                                    <InstagramOutlined />
                                </a>
                                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                                    <LinkedinOutlined />
                                </a>
                            </Space>

                            {/* Partner Section */}
                            <div className="footer-partner-inline">
                                <span>Partenaires officiels :</span>
                                <a href="https://yango.com" target="_blank" rel="noopener noreferrer" className="partner-logo">
                                    <img
                                        src={YangoLogo}
                                        alt="Yango"
                                        height="50"
                                    />
                                </a>
                                <a href="https://waren.ci" target="_blank" rel="noopener noreferrer" className="partner-logo">
                                    <img
                                        src={WarenLogo}
                                        alt="WAREN"
                                        height="50"
                                    />
                                </a>
                            </div>
                        </div>
                    </Col>

                    {/* Quick Links */}
                    <Col xs={12} sm={12} md={8}>
                        <div className="footer-section">
                            <h4 className="footer-title">Liens Rapides</h4>
                            <ul className="footer-links">
                                <li><Link to="/">Accueil</Link></li>
                                <li><Link to="/features">Fonctionnalités</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                                <li><Link to="/privacy">Politique de confidentialité</Link></li>
                            </ul>
                        </div>
                    </Col>

                    {/* Contact */}
                    <Col xs={12} sm={12} md={8}>
                        <div className="footer-section">
                            <h4 className="footer-title">Contact</h4>
                            <ul className="footer-contact">
                                <li>
                                    <MailOutlined />
                                    <span>support@tigoon.ci</span>
                                </li>
                                <li>
                                    <PhoneOutlined />
                                    <span>+225 27 22 20 81 23</span>
                                </li>
                                <li>
                                    <EnvironmentOutlined />
                                    <span>Bingerville, Abidjan, Côte d'Ivoire</span>
                                </li>
                            </ul>
                        </div>
                    </Col>
                </Row>

                {/* Download Section */}
                <div className="footer-download">
                    <span>Téléchargez l'application :</span>
                    <Space size={12}>
                        <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" className="store-badge">
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                                alt="Google Play"
                                height="40"
                            />
                        </a>
                        {APP_STORE_AVAILABLE ? (
                            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="store-badge">
                                <img
                                    src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                                    alt="App Store"
                                    height="40"
                                />
                            </a>
                        ) : (
                            <div className="store-badge-coming-soon">
                                <AppleOutlined />
                                <span>Bientôt disponible</span>
                            </div>
                        )}
                    </Space>
                </div>

                {/* Copyright */}
                <div className="footer-copyright">
                    <p>&copy; {COPYRIGHT_YEAR} {APP_NAME}. Tous droits réservés.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
